/* Functions for getting feature flags env variables to prevent referencing them in many places */
export const getLDClientKey = () => process.env.REACT_APP_LAUNCHDARKLY_CLIENTID;
/*
  Keys of LaunchDarkly flags added for this application:
    test1: (boolean) Used only in dev testing to validate the feature flag process
    productWorkInProgressBanner: (boolean) Gates Work In Progress Banner
    productIncidentsManagement: (boolean) Gates Incidents Management

  From using withLDProvider w/ streaming, components using a flag from useFlags() should automatically re-render if that flag changes.
  Flag values at the time of app load can be read by inspecting the event stream data of the request to https://clientstream.launchdarkly.com/
*/
